import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-brand-line bg-brand-cream px-4 py-5" data-id="element-157" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-4xl" data-id="element-158" data-mp="3fym86mxaf65e">
        <div className="mb-2 text-center" data-id="element-159" data-mp="3fxb38js3vscp">
          <h2 className="mb-0.5 font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-160" data-mp="3b1cjxalmx0j5">
            Cosa dicono i nostri utenti
          </h2>
          <p className="font-display text-[11px] font-semibold uppercase tracking-wide text-brand-orange sm:text-sm" data-id="element-161" data-mp="36wmr5um9w22g">
            ⭐⭐⭐⭐⭐ 4,9/5 — Recensioni Verificate
          </p>
        </div>
        <div className="space-y-2" data-id="element-162" data-mp="2x2mmtuytf0us">
          {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-xl border border-brand-line bg-white p-3 shadow-sm" data-id="element-163" data-mp="2s3jjqg2eb4pg">
              <div className="mb-1 flex gap-0.5" aria-label="Valutazione 5 su 5" data-id="element-164" data-mp="qbetd90jofgu">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-165" data-mp="h4n4wev9c5ci" />)}
              </div>
              <p className="mb-2 text-xs font-medium italic leading-snug text-brand-muted sm:text-sm" data-id="element-166" data-mp="c6vexqe6atay">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-2.5 border-t border-brand-line pt-2" data-id="element-167" data-mp="zwy1jqzbj726">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-orange/15 font-display text-sm font-extrabold text-brand-orange" data-id="element-168" data-mp="14u7qz6mpjiq0">
                  {testimonial.author.charAt(0)}
                </span>
                <div className="leading-tight" data-id="element-169" data-mp="v3d0fq2fhwyr">
                  <p className="font-display text-[13px] font-bold text-brand-ink" data-id="element-170" data-mp="1iu90fah1fyh3">
                    {testimonial.author}
                  </p>
                  <p className="text-[10px] font-semibold uppercase tracking-wide text-brand-muted sm:text-[11px]" data-id="element-171" data-mp="1nnv44d584s0r">
                    {testimonial.role} — {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}